export const topBarHeight = 64;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;

// OrgRole — matches OrgRole table (Id → Name)
export const ORG_ROLES = {
    1: 'Owner',
    2: 'Manager',
    3: 'Member',
    4: 'Guest',
};

// SiteRole — matches SiteRole table (Id → Name)
export const SITE_ROLES = {
    1: 'Member',
    2: 'Manager',
    3: 'Guest',
};

// Array form for use in Select/MenuItem components
export const SITE_ROLE_OPTIONS = Object.entries(SITE_ROLES).map(([value, label]) => ({
    value: Number(value),
    label,
}));
